import React, { useEffect } from "react";
import { Outlet, useNavigate } from "react-router-dom";

export const ProtectedRoute = () => {
  let token = localStorage.getItem("token");
  const navigate = useNavigate();

  useEffect(() => {
    if (!token || token === "") {
      navigate("/authenticate/connexion");
    }
  });

  return <>{token || token !== "" ? <Outlet /> : null}</>;
};
